import queryString from 'query-string'
import { texts } from 'utils/geo'
import { getGeoParams } from 'utils/parameters'
import TreeNodeResolver from 'routes/Filter/SearchParam/Tree/TreeNodeResolver'

export const getInitialParams = (location, regionParameter, allOptions) => {
  const queryParams = queryString.parse(location.search)
  const getParams = getGeoParams(queryParams)
  const { r, ag } = queryParams

  const getParamsResolved = r && regionParameter && TreeNodeResolver(regionParameter)(getParams)

  const flattenedParamValues = getParamsResolved && [
    ...getParamsResolved.r,
    ...getParamsResolved.m,
    ...getParamsResolved.sa,
  ]
  const initialParams = []

  if (flattenedParamValues) {
    flattenedParamValues.map((paramValue) => {
      return initialParams.push(
        allOptions.find(
          (option) => option.label === paramValue.label && option.level === paramValue.level,
        ),
      )
    })
  }

  const paramsWithoutNullValues = initialParams.filter((item) => item)
  let paramInitialValues = paramsWithoutNullValues
  const filterLevelThree = paramsWithoutNullValues.filter((value) => value.level === 3)
  if (filterLevelThree && filterLevelThree.length > 0) {
    paramInitialValues = paramsWithoutNullValues.filter((value) => value.level !== 2)
  }
  if (ag) {
    paramInitialValues = [
      ...paramInitialValues,
      { label: texts.ADJACENT_MUNICIPALITIES, value: 'ag=1', level: 1 },
    ]
  }

  let initialState = [{ label: texts.ALL_SWEDEN, value: '', level: 1 }]

  if (paramInitialValues.length > 0) {
    const noMandSaSelected = paramInitialValues.filter((value) => value.level > 1).length === 0
    if (noMandSaSelected) {
      initialState = [
        ...paramInitialValues,
        { label: texts.ALL_MUNICIPALITIES, value: queryString.stringify({ r }), level: 2 },
      ]
    } else {
      initialState = paramInitialValues
    }
  }
  return initialState
}
